import React, { useState, useRef, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { BrowserQRCodeReader } from "@zxing/library";
import axios from "axios";

import Footer from "../ComponentPrimer/Footer";

const ScanQrGathering = () => {
  const [qrCodeResult, setQrCodeResult] = useState("Invalid");
  const [email, setEmail] = useState("Invalid");
  const [whatsapp, setWhatsapp] = useState("Invalid");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [modalType, setModalType] = useState("success");
  const [isScanning, setIsScanning] = useState(true);
  const [countdown, setCountdown] = useState(5); // State for countdown
  const videoRef = useRef(null);
  const timerRef = useRef(null); // Ref to store the timer ID

  useEffect(() => {
    const codeReader = new BrowserQRCodeReader();

    const startScanning = async () => {
      try {
        if (isScanning) {
          await codeReader.decodeFromVideoDevice(null, videoRef.current, (result, error) => {
            if (result) {
              setQrCodeResult(result.getText());
              checkAndUpdateQRCode(result.getText());
              setIsScanning(false);
            }
            if (error) {
              console.error("Error:", error);
              resetScan();
            }
          });
        }
      } catch (err) {
        console.error("Failed to initialize scanner:", err);
        resetScan();
      }
    };

    startScanning();

    return () => {
      codeReader.reset();
      if (timerRef.current) clearTimeout(timerRef.current); // Clear timer on cleanup
    };
  }, [isScanning]);

  useEffect(() => {
    if (modalOpen && countdown > 0) {
      timerRef.current = setTimeout(() => {
        setCountdown(countdown - 1); // Decrease countdown every second
      }, 1000);
    } else if (countdown === 0) {
      toggleModal(); // Close modal after countdown reaches 0
    }

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current); // Cleanup timer when modal is closed
    };
  }, [modalOpen, countdown]);

  const checkAndUpdateQRCode = (qrData) => {
    if (qrData === "Invalid") return;

    axios
      .get(`https://rlagency.id/app/api_gathering_upi/check-qrcode.php?qrcode=${qrData}`)
      .then((response) => {
        if (response.data.exists) {
          setEmail(response.data.email);
          setWhatsapp(response.data.whatsapp);
          sendToAPI(response.data.email, response.data.whatsapp);
        } else {
          resetScan();
          showFailureModal();
        }
      })
      .catch((error) => {
        console.error("Error checking QR Code:", error);
        resetScan();
        showFailureModal();
      });
  };

  const sendToAPI = (email, whatsapp) => {
    axios
      .post("https://rlagency.id/app/api_gathering_upi/self_check_in.php", {
        email,
        whatsapp,
      })
      .then((response) => {
        if (response.data.success) {
          setModalMessage("Check-in Berhasil!");
          setModalType("success");
        } else {
          setModalMessage("Check-in Gagal!");
          setModalType("failure");
        }
        setModalOpen(true);
        setCountdown(5); // Reset countdown when modal is opened
      })
      .catch((error) => {
        console.error("Error sending data to API:", error);
        setModalMessage("Check-in Gagal!");
        setModalType("failure");
        setModalOpen(true);
        setCountdown(5); // Reset countdown when modal is opened
      });
  };

  const showFailureModal = () => {
    setModalMessage("Log-In Gagal!");
    setModalType("failure");
    setModalOpen(true);
    setCountdown(5); // Reset countdown when modal is opened
  };

  const toggleModal = () => {
    setModalOpen(!modalOpen);
    setIsScanning(true);
    resetScan();
  };

  const resetScan = () => {
    setQrCodeResult("Invalid");
    setEmail("Invalid");
    setWhatsapp("Invalid");
    setCountdown(5); // Reset countdown when scan is reset
  };

  return (
    <div className="container">
      <div style={{ maxWidth: "700px", margin: "50px auto" }}>
        <h1 style={{ fontSize: "24px", textTransform: "uppercase", fontWeight: "600" }}>
          Check In Gathering Event
        </h1>

        <div>
          <video ref={videoRef} width="100%" height="auto" style={{ border: "1px solid black" }} />
        </div>

        <p><strong>Email:</strong> {email}</p>
        <p><strong>WhatsApp:</strong> {whatsapp}</p>

        <Modal isOpen={modalOpen} toggle={toggleModal} size="sm" centered>
          <ModalHeader toggle={toggleModal}>{modalMessage}</ModalHeader>
          <ModalBody>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  margin: "10px auto",
                  width: "100%",
                  maxWidth: "400px",
                  textAlign: "center",
                }}
              >
                <p><strong>QR Code:</strong><br />{qrCodeResult}</p>
                <p><strong>Email:</strong><br />{email}</p>
                <p><strong>WhatsApp:</strong><br />{whatsapp}</p>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="btn btn-secondary" onClick={toggleModal}>
              Close ({countdown})
            </button>
          </ModalFooter>
        </Modal>
      </div>
      <Footer />
    </div>
  );
};

export default ScanQrGathering;
